import { render, staticRenderFns } from "./courseDetail.vue?vue&type=template&id=e989cb1e&scoped=true"
import script from "./courseDetail.vue?vue&type=script&lang=js"
export * from "./courseDetail.vue?vue&type=script&lang=js"
import style0 from "./courseDetail.vue?vue&type=style&index=0&id=e989cb1e&prod&lang=less&scoped=true"
import style1 from "./courseDetail.vue?vue&type=style&index=1&id=e989cb1e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e989cb1e",
  null
  
)

export default component.exports